/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Nav_Hellouser1Inputs */

const id_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halo, ${i?.name}!`)
};

const ms_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai, ${i?.name}!`)
};

const da_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hej, ${i?.name}!`)
};

const de_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hallo, ${i?.name}!`)
};

const en_us2_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello, ${i?.name}!`)
};

const es_es2_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Hola, ${i?.name}!`)
};

const es_mx2_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Hola, ${i?.name}!`)
};

const fil_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello, ${i?.name}!`)
};

const fr_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bonjour, ${i?.name} !`)
};

const it_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ciao, ${i?.name}!`)
};

const hu_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Szia, ${i?.name}!`)
};

const nl_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hallo, ${i?.name}!`)
};

const no_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hei, ${i?.name}!`)
};

const pl_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Witaj, ${i?.name}!`)
};

const pt_br2_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olá, ${i?.name}!`)
};

const pt_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olá, ${i?.name}!`)
};

const ro_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bună, ${i?.name}!`)
};

const fi_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hei, ${i?.name}!`)
};

const sv_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hej, ${i?.name}!`)
};

const vi_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xin chào, ${i?.name}!`)
};

const tr_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Merhaba, ${i?.name}!`)
};

const cs_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ahoj, ${i?.name}!`)
};

const bg_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Здравейте, ${i?.name}!`)
};

const ru_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Здравствуйте, ${i?.name}!`)
};

const uk_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Привіт, ${i?.name}!`)
};

const ar_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مرحبًا، ${i?.name}!`)
};

const hi_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`नमस्ते, ${i?.name}!`)
};

const th_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สวัสดี ${i?.name}!`)
};

const ja_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`こんにちは、${i?.name}さん！`)
};

const zh_cn2_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您好，${i?.name}！`)
};

const zh_hant1_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您好，${i?.name}！`)
};

const ko_nav_hellouser1 = /** @type {(inputs: Nav_Hellouser1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`안녕하세요, ${i?.name}님!`)
};

/**
* | output |
* | --- |
* | "Hello, {name}!" |
*
* @param {Nav_Hellouser1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_hellouser1 = /** @type {((inputs: Nav_Hellouser1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Hellouser1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_hellouser1(inputs)
	if (locale === "ms") return ms_nav_hellouser1(inputs)
	if (locale === "da") return da_nav_hellouser1(inputs)
	if (locale === "de") return de_nav_hellouser1(inputs)
	if (locale === "en-US") return en_us2_nav_hellouser1(inputs)
	if (locale === "es-ES") return es_es2_nav_hellouser1(inputs)
	if (locale === "es-MX") return es_mx2_nav_hellouser1(inputs)
	if (locale === "fil") return fil_nav_hellouser1(inputs)
	if (locale === "fr") return fr_nav_hellouser1(inputs)
	if (locale === "it") return it_nav_hellouser1(inputs)
	if (locale === "hu") return hu_nav_hellouser1(inputs)
	if (locale === "nl") return nl_nav_hellouser1(inputs)
	if (locale === "no") return no_nav_hellouser1(inputs)
	if (locale === "pl") return pl_nav_hellouser1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_hellouser1(inputs)
	if (locale === "pt") return pt_nav_hellouser1(inputs)
	if (locale === "ro") return ro_nav_hellouser1(inputs)
	if (locale === "fi") return fi_nav_hellouser1(inputs)
	if (locale === "sv") return sv_nav_hellouser1(inputs)
	if (locale === "vi") return vi_nav_hellouser1(inputs)
	if (locale === "tr") return tr_nav_hellouser1(inputs)
	if (locale === "cs") return cs_nav_hellouser1(inputs)
	if (locale === "bg") return bg_nav_hellouser1(inputs)
	if (locale === "ru") return ru_nav_hellouser1(inputs)
	if (locale === "uk") return uk_nav_hellouser1(inputs)
	if (locale === "ar") return ar_nav_hellouser1(inputs)
	if (locale === "hi") return hi_nav_hellouser1(inputs)
	if (locale === "th") return th_nav_hellouser1(inputs)
	if (locale === "ja") return ja_nav_hellouser1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_hellouser1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_hellouser1(inputs)
	return ko_nav_hellouser1(inputs)
});
export { nav_hellouser1 as "nav.helloUser" }